var map = {
	"./scenery-1.png": "7a92",
	"./scenery-10.png": "22a2",
	"./scenery-11.png": "54ae",
	"./scenery-12.png": "5303",
	"./scenery-13.png": "99ff",
	"./scenery-14.png": "688a",
	"./scenery-15.png": "2f67",
	"./scenery-2.png": "2796",
	"./scenery-3.png": "6541",
	"./scenery-4.png": "a0a5",
	"./scenery-5.png": "1540",
	"./scenery-6.png": "e7fb",
	"./scenery-7.png": "a23f",
	"./scenery-8.png": "ef74",
	"./scenery-9.png": "6f70"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87ee";